import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Link from 'next/link'
import { Auth } from 'aws-amplify';
import { useUser, IUserContext } from 'components/contexts/UserContext';
import {  useCurrentIdToken } from 'lib/AuthUtils';
import { CognitoIdToken } from '@xeedware/cognito-jwt';
import { useDispatch, useSelector } from 'react-redux';
import { IUserSlice, currentUserSelector, logout } from 'features/me/meSlice';
import { useRouter } from 'next/router';
import { LOGOUT_PATH } from 'lib/Constants';
import User from 'backend/models/User';


const SidebarFooterIcon = () => {

    const idToken:CognitoIdToken = useCurrentIdToken();
    const dispatch = useDispatch();
    const router = useRouter();
    const currentUserSlice:IUserSlice = useSelector(currentUserSelector());
    const currentUser = new User(currentUserSlice);


  
    const onLogout = (evt:any) => {
      evt.preventDefault();
      (async () => {
        try {
          dispatch(logout());
          await Auth.signOut();
        } catch(error) {
          console.error(error);
        } finally {
          router.push(LOGOUT_PATH, undefined, { shallow: true });
        }
        
      })();
      
 
    };
    return ( 
         <DropdownButton drop='up' id='sidebar_footer_icon' title={currentUser?.displayInitials() ?? ''}>
            {/*
            <Dropdown.Item className='sidebar_footer_items'><Link href='/admin/me' className='sidebar_footer_profile'>Profile</Link></Dropdown.Item>
            */}
            <Dropdown.Item className='sidebar_footer_items'><button className='sidebar_footer_logout' onClick={onLogout}> Log out </button></Dropdown.Item>
        </DropdownButton>
     );
}
 
export default SidebarFooterIcon;   
